import type {
  BusinessGetResponseType,
  UserCreateResponseType,
} from "@sellar-io/api-v2/types";
import type { useRemoteFeatureFlags } from "../hooks/useRemoteFeatureFlags";

type IsFeatureActive = ReturnType<typeof useRemoteFeatureFlags>["isActive"];

export const getAppRouteCapabilities = ({
  business,
  sellarUser,
  isFeatureActive,
}: {
  business: BusinessGetResponseType | null;
  sellarUser: UserCreateResponseType | null;
  isFeatureActive: IsFeatureActive;
}) => {
  const isUserLegalEntityAdmin = Boolean(
    sellarUser?.legalEntityAdminList.length,
  );
  const isUserSellarAdmin = sellarUser?.type === "admin";
  const canManageCompanyCreditSettings =
    business?.type === "retailer" &&
    (isUserLegalEntityAdmin || isUserSellarAdmin);
  const canAccessCreditTab =
    business?.type === "retailer" &&
    (canManageCompanyCreditSettings ||
      (Boolean(business.BusinessUser?.canAccessSellarCredit) &&
        Boolean(business.BusinessUser?.canViewSellarCreditBalance)));

  return {
    invoiceSettingsEnabled: isFeatureActive("invoicing"),
    inAppNotificationsActive: isFeatureActive("inAppNotifications"),
    unbundlingRelease2bEnabled: isFeatureActive("unbundlingRelease2B"),
    unbundlingRelease2aEnabled: isFeatureActive("unbundlingRelease2A"),
    unbundlingEnabled: isFeatureActive("unbundlingReleaseFinal"),
    supplierOrderPromotionsEnabled: isFeatureActive("supplierOrderPromotions"),
    sellarDistributionBetaEnabled: isFeatureActive("sellarDistributionBeta"),
    canManageCompanyCreditSettings,
    canAccessCreditTab,
  };
};
